import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchVacsForLitter } from "actions/vacs";
import Section from "components/layout/Section";
import EntryCardWithStatus from "components/cards/Entry_Card_With_Status";
import Message from "components/message";

class ViewEntries extends Component {
  UNSAFE_componentWillMount() {
    const { _litter, vacs } = this.props;
    if (!vacs.fetched.includes(_litter)) {
      this.props.fetchVacsForLitter(_litter);
    }
  }

  renderSectionContent() {
    const { vacs, _litter } = this.props;
    const { entries } = vacs;

    const entriesFiltered = entries.filter(
      (entry) => entry._litter === _litter
    );

    if (entriesFiltered.length === 0) {
      return <Message warning message={"noEntriesToDisplayAutoFetch"} />;
    }

    return (
      <div className="columns is-2 is-variable is-mobile is-multiline is-centered">
        {entriesFiltered.map((entry, i) => (
          <div
            key={i}
            className="column is-full-mobile is-3-desktop is-4-tablet"
          >
            <EntryCardWithStatus
              vacEntry
              litterMember
              to={`/userhome/dashboard/litter/vaccinations/view_entries`}
              key={i}
              {...entry}
            />
          </div>
        ))}
      </div>
    );
  }

  render() {
    return <Section>{this.renderSectionContent()}</Section>;
  }
}

const mapStateToProps = (state) => {
  return {
    _litter: state.reducers.litters.selectedLitter._id,
    vacs: state.reducers.vacs,
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      fetchVacsForLitter,
      dispatch,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewEntries);
